/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lustrace_History_QueryInputs */

const cs_lustrace_history_query = /** @type {(inputs: Lustrace_History_QueryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dotaz`)
};

const en_lustrace_history_query = /** @type {(inputs: Lustrace_History_QueryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Query`)
};

/**
* | output |
* | --- |
* | "Query" |
*
* @param {Lustrace_History_QueryInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const lustrace_history_query = /** @type {((inputs?: Lustrace_History_QueryInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lustrace_History_QueryInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lustrace_history_query(inputs)
	return cs_lustrace_history_query(inputs)
});